import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CurrencyPairCalendarLookupService } from "../../lookup/model/impl/CurrencyPairCalendarLookupService";
import { COLUMN_VAL_DT } from "../ScratchPadTableDefinitionFactory.constants";
import { ScratchPadOrder } from "./ScratchPadOrder";

export class ValueDateSCHelper {
  protected localeString: string = "DD-MMM-YY";

  constructor(protected currencyPairCalendarLookupService: CurrencyPairCalendarLookupService) {}

  retrieveData(order: ScratchPadOrder): string {
    switch (order.product) {
      case CubiqTS.Product.SPT:
      case CubiqTS.Product.FWD:
      case CubiqTS.Product.NDF:
        return this.getSingleValueDate(order);
      case CubiqTS.Product.SWP:
        return order.swapValueDate;
      case CubiqTS.Product.SSP:
        return "MULTIPLE";
    }
  }

  /**
   * Create visual representation of Value date in Scratch pad
   * @param order
   * @returns
   */
  private getSingleValueDate(order: ScratchPadOrder): string {
    let valueDateStr: string = "";
    if (order.valueDate) {
      let moment: CubiqTS.Moment = this.getDate(order, COLUMN_VAL_DT);
      if (moment) {
        valueDateStr = `${moment.utc().format(this.localeString)}`;
      } else {
        valueDateStr = `-`;
      }
    }
    let tenorStr = "";
    let tenor: any = order.tenor;
    if (tenor) {
      tenorStr = this.getTenorStr(tenor);
    }
    if (tenorStr && valueDateStr) {
      return `${tenorStr} (${valueDateStr})`;
    }
    if (tenorStr) {
      return tenorStr;
    }
    if (valueDateStr) {
      return valueDateStr;
    }
    return this.getTenorStr(CubiqTS.Tenor.SPOT);
  }

  retrieveSort(order: any, columnProperty: string): number {
    let tenor: any = order.tenor;

    if (tenor) {
      return order.tenor;
    } else if (order.valueDate) {
      let valueDate = order.valueDate as CubiqTS.StandardDate;
      return valueDate.year * 1000 + valueDate.month * 100 + valueDate.day;
    }

    return order.tenor;
  }

  private getDate(adaptee: any, columnProperty: string): CubiqTS.Moment {
    let dt: any = adaptee[columnProperty];
    if (CubiqTS.moment.isMoment(dt)) {
      // TODO: offset conditions with TZ are lost over subjects
      // this reapplies tz offset conditions on a fresh moment instance
      return dt.utc().local();
    } else if (CubiqTS.Long.isLong(dt)) {
      // moment accepts unix milliseconds seconds in this format
      let dtM = CubiqTS.moment((dt as CubiqTS.Long).toNumber());
      return dtM;
    } else if (typeof dt === "string") {
      // FIXME: Cubiq-TS decode ISO string to moment
      // iso string from CUBIQTS miss decode
      // let dtM = moment(dt, "YYYY-MM-DD HH:mm:ss");

      let dtM = CubiqTS.moment(Number(dt));

      // TODO tz support- cubiq-ts is always UTC
      return dtM;
    } else if (dt && dt.toLocaleDateString) {
      return CubiqTS.moment(dt);
    } else if (dt instanceof CubiqTS.StandardDateImpl) {
      return CubiqTS.moment.tz([dt.year, dt.month - 1, dt.day], "UTC");
    }
    return null;
  }

  getTenorStr(tenor: CubiqTS.Tenor): string {
    switch (tenor) {
      case CubiqTS.Tenor.TDY:
        return "TDY";
      case CubiqTS.Tenor.TOM:
        return "TOM";
      case CubiqTS.Tenor.SPOT:
        return "SP";
      case CubiqTS.Tenor.W1:
        return "1W";
      case CubiqTS.Tenor.W2:
        return "2W";
      case CubiqTS.Tenor.W3:
        return "3W";
      case CubiqTS.Tenor.M1:
        return "1M";
      case CubiqTS.Tenor.M2:
        return "2M";
      case CubiqTS.Tenor.M3:
        return "3M";
      case CubiqTS.Tenor.M4:
        return "4M";
      case CubiqTS.Tenor.M5:
        return "5M";
      case CubiqTS.Tenor.M6:
        return "6M";
      case CubiqTS.Tenor.M7:
        return "7M";
      case CubiqTS.Tenor.M8:
        return "8M";
      case CubiqTS.Tenor.M9:
        return "9M";
      case CubiqTS.Tenor.M10:
        return "10M";
      case CubiqTS.Tenor.M11:
        return "11M";
      case CubiqTS.Tenor.Y1:
        return "1Y";
      case CubiqTS.Tenor.M13:
        return "13M";
      case CubiqTS.Tenor.M14:
        return "14M";
      case CubiqTS.Tenor.M15:
        return "15M";
      case CubiqTS.Tenor.M16:
        return "16M";
      case CubiqTS.Tenor.M17:
        return "17M";
      case CubiqTS.Tenor.M18:
        return "18M";
      case CubiqTS.Tenor.M19:
        return "19M";
      case CubiqTS.Tenor.M20:
        return "20M";
      case CubiqTS.Tenor.M21:
        return "21M";
      case CubiqTS.Tenor.M22:
        return "22M";
      case CubiqTS.Tenor.M23:
        return "23M";
      case CubiqTS.Tenor.Y2:
        return "2Y";
      case CubiqTS.Tenor.Y3:
        return "3Y";
      case CubiqTS.Tenor.Y4:
        return "4Y";
      case CubiqTS.Tenor.Y5:
        return "5Y";
      case CubiqTS.Tenor.SN:
        return "SN";
      case CubiqTS.Tenor.ALL:
        return "All";
    }
    return CubiqTS.Tenor[tenor];
  }
}
